module.exports = __webpack_public_path__ + "img/avatar2.7d151dae.png";